/* TENSO — PDP bundle configurator */
(function(){
  "use strict";

  /* Amount only — the Riyal symbol is prepended as markup in setPrice(). */
  function fmt(cents){
    var n=cents/100;
    return (n%1===0)?n.toLocaleString('en-US'):n.toLocaleString('en-US',{minimumFractionDigits:2,maximumFractionDigits:2});
  }
  function fire(name){document.dispatchEvent(new CustomEvent(name));}

  /* Writes symbol + amount. Falls back to plain text if the symbol asset is
     missing, so a failed script load degrades to a readable price, not a blank. */
  function setPrice(el,amountText){
    var svg=window.TENSO_RIYAL_SVG;
    if(svg){ el.innerHTML = svg + '<span data-total-amt></span>';
             el.querySelector('[data-total-amt]').textContent = amountText; }
    else   { el.textContent = 'SAR ' + amountText; }
  }

  function init(){
    var root=document.querySelector('[data-pdpx]');
    if(!root) return;

    var comps=[].slice.call(root.querySelectorAll('[data-comp]'));
    var totalEls=[].slice.call(root.querySelectorAll('[data-total]'));
    var configEl=root.querySelector('[data-config-line]');
    var completeLabel=root.getAttribute('data-complete-label')||'Complete Set';

    function selected(){return comps.filter(function(c){return c.checked;});}

    function update(){
      var sel=selected();
      comps.forEach(function(c){c.disabled=(sel.length===1&&c.checked);});
      var missing=false,total=0;
      sel.forEach(function(c){
        var p=parseInt(c.getAttribute('data-price'),10)||0;
        if(p<=0)missing=true;total+=p;
      });
      var text=(missing||!sel.length)?'———':fmt(total);
      totalEls.forEach(function(el){setPrice(el,text);});
      if(configEl){
        configEl.textContent=(sel.length===comps.length)?completeLabel:
          sel.map(function(c){return c.getAttribute('data-title');}).join(' + ');
      }
      comps.forEach(function(c){
        var row=c.closest('.pdpx__row');
        if(row)row.classList.toggle('is-off',!c.checked);
      });
      try{
        var u=new URL(window.location.href);
        u.searchParams.set('set',sel.map(function(c){return c.getAttribute('data-key');}).join(','));
        history.replaceState(null,'',u);
      }catch(e){}
    }

    /* Deep link: ?set=duvet,sheets */
    try{
      var param=new URL(window.location.href).searchParams.get('set');
      if(param){
        var keys=param.split(',');var any=false;
        comps.forEach(function(c){
          var on=keys.indexOf(c.getAttribute('data-key'))!==-1;
          if(on)any=true;c.checked=on;
        });
        if(!any&&comps[0])comps[0].checked=true;
      }
    }catch(e){}

    comps.forEach(function(c){c.addEventListener('change',update);});
    update();

    /* Row expanders — independent of selection state */
    [].slice.call(root.querySelectorAll('[data-expand]')).forEach(function(btn){
      btn.addEventListener('click',function(){
        var row=btn.closest('.pdpx__row');
        var d=row?row.querySelector('.pdpx__row-detail'):null;
        var open=btn.getAttribute('aria-expanded')==='true';
        btn.setAttribute('aria-expanded',String(!open));
        if(d)d.hidden=open;
      });
    });

    /* Add to cart — each selected component becomes its own line item */
    function addToCart(btn){
      var sel=selected();
      var msg=root.querySelector('[data-atc-msg]');
      var items=sel.map(function(c){return {id:parseInt(c.getAttribute('data-vid'),10)||0,quantity:1};});
      if(!items.length||items.some(function(i){return !i.id;})){if(msg)msg.hidden=false;return;}
      if(msg)msg.hidden=true;
      btn.setAttribute('aria-busy','true');

      /* Raise the floating chip now, before the request. /cart/add.js takes
         560-690ms; waiting for it before any feedback reads as lag. The chip
         shows no count until the server agrees one — see tenso-bag.js. */
      fire('tenso:bag:pending');

      var rootPath=(window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/';
      fetch(rootPath+'cart/add.js',{
        method:'POST',
        headers:{'Content-Type':'application/json','Accept':'application/json'},
        body:JSON.stringify({items:items})
      }).then(function(r){if(!r.ok)throw new Error('add');return r.json();})
        .then(function(){
          /* Stay on the PDP. Redirecting to /cart used to end the browsing
             session at the first add. */
          btn.removeAttribute('aria-busy');
          fire('tenso:bag:added');
        })
        .catch(function(){
          btn.removeAttribute('aria-busy');
          if(msg)msg.hidden=false;
          /* retract the chip — a failed add must not leave a confirmation up */
          fire('tenso:bag:failed');
        });
    }
    [].slice.call(root.querySelectorAll('[data-atc]')).forEach(function(b){
      b.addEventListener('click',function(e){e.preventDefault();addToCart(b);});
    });

    /* Waitlist CTA mode — opens the theme's waitlist pop-up */
    [].slice.call(root.querySelectorAll('[data-waitlist-cta]')).forEach(function(b){
      b.addEventListener('click',function(){
        var wl=document.getElementById('TensoWaitlist');
        if(wl){wl.classList.add('is-open');wl.setAttribute('aria-hidden','false');document.body.style.overflow='hidden';}
      });
    });

    /* Gallery: thumbs (desktop) + snap carousel dots (mobile) + lightbox */
    var frames=[].slice.call(root.querySelectorAll('[data-frame]'));
    var thumbs=[].slice.call(root.querySelectorAll('[data-thumb]'));
    var framesWrap=root.querySelector('[data-frames]');
    var dotsWrap=root.querySelector('[data-dots]');

    function setDots(i){
      if(!dotsWrap)return;
      [].slice.call(dotsWrap.children).forEach(function(d,j){d.classList.toggle('is-active',i===j);});
    }
    function show(i){
      frames.forEach(function(f,j){f.classList.toggle('is-active',i===j);});
      thumbs.forEach(function(t,j){t.classList.toggle('is-active',i===j);});
      setDots(i);
    }
    thumbs.forEach(function(t){
      t.addEventListener('click',function(){show(parseInt(t.getAttribute('data-thumb'),10)||0);});
    });
    if(dotsWrap&&frames.length>1){
      frames.forEach(function(_,i){
        var d=document.createElement('button');
        d.type='button';d.className='pdpx__dot'+(i===0?' is-active':'');
        d.setAttribute('aria-label','Image '+(i+1));
        d.addEventListener('click',function(){
          if(framesWrap)framesWrap.scrollTo({left:framesWrap.clientWidth*i,behavior:'smooth'});
        });
        dotsWrap.appendChild(d);
      });
    }
    if(framesWrap){
      framesWrap.addEventListener('scroll',function(){
        var w=framesWrap.clientWidth;if(!w)return;
        setDots(Math.round(framesWrap.scrollLeft/w));
      },{passive:true});
    }

    var lb=root.querySelector('[data-lightbox]');
    if(lb&&window.matchMedia('(min-width:1024px)').matches){
      var lbImg=lb.querySelector('img');
      frames.forEach(function(f){
        f.addEventListener('click',function(){
          var img=f.querySelector('img');if(!img)return;
          lbImg.src=img.getAttribute('data-full')||img.src;
          lbImg.alt=img.alt||'';
          if(lb.showModal)lb.showModal();
        });
      });
      lb.addEventListener('click',function(e){if(e.target===lb)lb.close();});
      var lbx=lb.querySelector('[data-lb-close]');
      if(lbx)lbx.addEventListener('click',function(){lb.close();});
    }

    /* Size guide modal */
    var sg=root.querySelector('[data-size-modal]');
    [].slice.call(root.querySelectorAll('[data-size-open]')).forEach(function(b){
      b.addEventListener('click',function(e){e.preventDefault();if(sg&&sg.showModal)sg.showModal();});
    });
    if(sg){
      var sgx=sg.querySelector('[data-modal-close]');
      if(sgx)sgx.addEventListener('click',function(){sg.close();});
      sg.addEventListener('click',function(e){if(e.target===sg)sg.close();});
    }

    /* Read more */
    var rm=root.querySelector('[data-readmore]');
    var descBody=root.querySelector('[data-desc-body]');
    if(rm&&descBody){
      if(descBody.scrollHeight<=descBody.clientHeight+4)rm.hidden=true;
      rm.addEventListener('click',function(){
        var clamped=descBody.classList.toggle('is-clamped');
        rm.textContent=clamped?rm.getAttribute('data-more'):rm.getAttribute('data-less');
      });
    }

    /* Mobile sticky CTA bar */
    var bar=root.querySelector('[data-stickybar]');
    var anchor=root.querySelector('[data-cta-anchor]');
    if(bar&&anchor&&'IntersectionObserver' in window){
      var io=new IntersectionObserver(function(entries){
        var e=entries[0];
        var below=e.boundingClientRect.top<0;
        bar.classList.toggle('is-shown',!e.isIntersecting&&below);
      },{threshold:0});
      io.observe(anchor);
    }
  }

  if(document.readyState!=='loading')init();
  else document.addEventListener('DOMContentLoaded',init);
})();
